module.exports = __webpack_public_path__ + "static/media/nynfc_history.4f3f156e.png";